var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 134,
    height: 134,
    viewBox: "0 0 134 134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0002 0.333984C30.2002 0.333984 0.333496 30.2007 0.333496 67.0007C0.333496 103.801 30.2002 133.667 67.0002 133.667C103.8 133.667 133.667 103.801 133.667 67.0007C133.667 30.2007 103.8 0.333984 67.0002 0.333984ZM48.9335 95.6007L25.0002 71.6673C22.4002 69.0673 22.4002 64.8673 25.0002 62.2673C27.6002 59.6673 31.8002 59.6673 34.4002 62.2673L53.6668 81.4673L99.5335 35.6007C102.133 33.0007 106.333 33.0007 108.933 35.6007C111.533 38.2007 111.533 42.4007 108.933 45.0007L58.3335 95.6007C55.8002 98.2007 51.5335 98.2007 48.9335 95.6007Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.83c1572d0f2993748320e838a665d957.svg";
export { ForwardRef as ReactComponent };